import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import { approvePathwayScormApproval } from '../../../api/pathwayScormApprovals';
import { PATHWAY_SCORM_APPROVALS_KEY } from './useGetPathwayScormApprovalsQuery';

const useApprovePathwayScormMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(id => approvePathwayScormApproval(id), {
    onSuccess: () => {
      queryClient.invalidateQueries(PATHWAY_SCORM_APPROVALS_KEY);
      message.success('Pathway SCORM changes approved');
    },
    onError: error => {
      const errorMessage =
        error?.response?.data?.error?.user_message ||
        error?.response?.data?.error ||
        'Failed to approve SCORM request';
      message.error(
        typeof errorMessage === 'string'
          ? errorMessage
          : 'Failed to approve SCORM request'
      );
    },
  });
};

export default useApprovePathwayScormMutation;
